var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BackgroundCarousel"},[(_vm.images.length > 0)?_c('el-carousel',{attrs:{"indicator-position":"none","arrow":"never"}},_vm._l((_vm.images),function(item,index){return _c('el-carousel-item',{key:`item-${index}`},[_c('div',{staticClass:"BackgroundCarousel__img",style:({
          'background-image': `url(${item})`
        })})])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }